"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getFileSize(bytes) {
  if (bytes === 0) return '';
  const base = 1024;
  const sizeUnits = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const unitIndex = Math.floor(Math.log(bytes) / Math.log(base));
  const formattedSize = Math.round(bytes / Math.pow(base, unitIndex) * 100) / 100;
  return "".concat(formattedSize, " ").concat(sizeUnits[unitIndex]);
}
var _default = exports.default = getFileSize;